module.exports = __webpack_public_path__ + "img/mc-off1.3146a8c2.gif";